module.exports = __webpack_public_path__ + "img/two-green-light.56c72283.svg";